import axios from 'axios'
import { AxiosDefaultOptions } from '@/services/config'

export const outsiderApiClient = axios.create(AxiosDefaultOptions)
